import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { userDetail } from '../../apiHelpers/user/detail';
import DialogActions from "@material-ui/core/DialogActions";
import {
  CircularProgress,
  Fade,
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
  InputLabel,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@material-ui/core";
import { withTheme } from "@material-ui/core/styles";
import * as actions from "../../actions";
import { connect } from "react-redux";
import { compose } from "redux";
import { validateSignInData } from "../../utils/validators/validateForm";
import { NotificationManager } from "react-notifications";
import { Redirect, withRouter } from "react-router-dom";
import {
  ROLE_CUSTOMER,
  ROLE_PROVIDER,
  countries,
  SERVER_URL,
} from "../../utils/config/constants";
import SocialSignin from "../../components/Social/SocialSignin";
import { FormattedMessage, injectIntl } from "react-intl";
import AppLinks from "../../components/About/AppLinks";
import CustomerVerification from "../../components/Customer/CustomerVerification";
import Verification from "../../components/Providers/Verification";
import ForgotPassword from "./ForgotPassword";
import axios from "axios";
import { cookies } from "../../utils/getToken";
import { cardList } from "../../apiHelpers/booking/list";

var resendTimer = 0;

class SigninForm extends React.Component {
  constructor(props) {
    super(props);
    console.log("Signin data", props)
    this.state = {
      loaderButton: false,
      email: "",
      password: "",
      showCustomerVerification: false,
      showProviderVerification: false,
      closeVerification: false,
      playerId: "",
      showForgotPopup: false,
      samePage: false,
      role: '',
      customerRedirect: false,
      providerRedirect: false,
      countryCode: "1",
      phone: "",
      hideLogin: true,
      hideGetOtp: false,
      is_otp: true,
      // timer: 10,
      accountType: "420",
      typeError: "",
      showChangePhone: false,
      phoneError: "",
      booking_data: this.props.history.location.state == undefined ? null : this.props.history.location.state.booking_data,
      taskData: this.props.history.location.state == undefined ? null : this.props.history.location.state.taskData,
      loginPath: this.props.history.location.state == undefined ? null : this.props.history.location.state.loginPath,
      value: this.props.history.location.state == undefined ? null : this.props.history.location.state.value,
      // key: 1,
      // res: cardList(),

    };
  }

  componentDidUpdate() {
    if (this.state.timer === 0) {
      clearInterval(this.time);
    }
  }

  componentDidMount() {
    this.props.removeHeaderAction(false);
    console.log("booking_data ON SIGN IN PAGE", this.state.booking_data);
    console.log("taskData ON SIGN IN PAGE", this.state.taskData);
    console.log("loginPath ON SIGN IN PAGE", this.state.loginPath);

  }
  componentWillUnmount() {
    this.props.removeHeaderAction(false);
    clearInterval(this.time);
  }
  renderLoginButton = () => {
    if (this.state.loaderButton) {
      return <CircularProgress />;
    } else {
      return (
        <button
          className="custom-button"
          onClick={() => this.loginActionCall()}
        ><span
          className="button-test-case">
            <FormattedMessage id="login" Login="Login" />
          </span>
        </button>
      );
    }
  };

  renderGetOtpButton = () => {
    if (this.state.loaderButton) {
      return <CircularProgress />;
    } else {
      return (
        <button className="custom-button" onClick={() => this.getOptCall()}>
          GET ONE TIME PASSWORD
          {/* <FormattedMessage id="login" defaultMessage="Login" /> */}
        </button>
      );
    }
  };

  getOptCall = () => {
    console.log("getOptCall");
    if (this.state.accountType == "") {
      this.setState({
        typeError: "Choose account type!",
      });
    } else {
      if (this.state.phone.length != 10 & this.state.phone.length != 0) {
        this.setState({
          phoneError: "phone length should be 10 *",
        });
      } else {
        this.setState({ loaderButton: true, timer: 90, showChangePhone: true });
        axios({
          method: "post",
          url: `${SERVER_URL}/otp/login`,
          data: {
            country_code: this.state.countryCode,
            phone: this.state.phone,
            role: this.state.accountType, //need to remove it
          },
        }).then((resJson) => {

          if (resJson.data.status == "OK") {
            NotificationManager.success("Success", resJson.data.message);
            this.time = setInterval(() => {
              this.setState((prevState) => ({
                timer: prevState.timer - 1,
              }));
            }, 1000);
            this.setState({
              loaderButton: false,
              hideLogin: false,
              hideGetOtp: true,
              showVerifyBtn: true,
              password: "",
            });
          } else {
            NotificationManager.error("Oops!", resJson.data.message);
            this.setState({
              loaderButton: false,
              password: "",
              showChangePhone: false,
            });
          }
        });
      }
    }
  };


  loginActionCall = async () => {
    console.log("Playerrrr ID", window.onesignalId);
    this.setState({ loaderButton: true });
    this.props.loginAction(
      {
        email: this.state.email,
        is_otp: this.state.is_otp,
        phone: this.state.phone,
        password: this.state.password,
        country_code: this.state.countryCode,
        playerId: window.onesignalId,
        role: this.state.accountType,
      },
      this.onDone
    );
  };
  handleError = (params) => {
    this.setState(params);
  };
  renderProviderVerification = (email) => {
    this.setState({ showProviderVerification: true, usedEmail: email });
  };
  renderCustomerVerification = (email) => {
    this.setState({ showCustomerVerification: true, usedEmail: email });
  };
  renderForgotPassword = (email) => {
    this.setState({ showForgotPopup: true, usedEmail: email });
  };




  onDone = async (success, data) => {
    this.setState({
      role: data.role,
    });

    console.log("data signin ", data);
    console.log(success, "success signin");

    // if(){

    // }

    if (success === "NOV") {
      console.log("if success NOV");

      if (data.role === ROLE_CUSTOMER) {
        console.log("if ROLE_CUSTOMER");
        this.setState({
          loaderButton: false,
          showCustomerVerification: true,
        }, () => {
          this.renderCustomerVerification(this.state.email);
          //this.handleClose();
        });
      } else if (data.role === ROLE_PROVIDER) {
        console.log("else if ROLE_PROVIDER");
        this.setState({
          loaderButton: false,
          showProviderVerification: true,
        }, () => {
          this.renderProviderVerification(this.state.email);
          //this.handleClose();
        });
      }
    } else if (success === true) {
      console.log("else if success true");
      console.log(":::::::::::::::::Inside else if1111:::::::::::::::", data.token);
      //cookies.remove('x-auth-token',{path: '/'})

      cookies.set('x-auth-token', data.token, { path: '/' });

      if (!this.props.renderSamePage) {
        console.log("!this.props.renderSamePage");

        if (this.state.role === ROLE_CUSTOMER) {
          console.log("if ROLE_CUSTOMER");
          this.setState({
            loaderButton: false,
            customerRedirect: true,
          });
        } else {
          console.log("if ROLE_PROVIDER");
          this.setState({
            loaderButton: false,
            providerRedirect: true,
          });
        }
      } else {
        console.log("RRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRR");
        this.setState({
          loaderButton: false,
          samePage: true,
        });
      }
    } else {
      console.log("else   success ");
      NotificationManager.error("Oops!", data.message);
      this.setState({
        loaderButton: false,
        emailError: data.message,
      });
    }
  };


  renderSignupPage = () => {
    this.props.history.push({
      pathname: '/signup',
      state: {
        taskData: this.state.taskData,
        booking_data: this.state.booking_data,
        value: this.state.value,
        loginPath: this.state.loginPath,
        taskDataFromConfirmPage: this.props.location.state.taskDataFromConfirmPage,
        BookingPath: this.props.history.location.state.BookingPath,
        taskDataFromConfirmPage: this.props.history.location.state.taskDataFromConfirmPage
      }
    });
  };

  handleForgotClose = () => {
    this.setState({ showForgotPopup: false });
  };
  handleCountryChange = (event) => {
    console.log({ event });
    this.setState({
      [event.target.name]: event.target.value,
      countryCodeError: "",
    });
  };

  handleChangeAccountType = (event) => {
    this.setState({
      accountType: event.target.value,
      showChangePhone: false,
      hideGetOtp: false,
      hideLogin: true,
      timer: 0,
    });
  };


  render() {
    const {
      passwordError,
      emailError,
      countryCodeError,
      hideLogin,
      phoneError,
    } = this.state;

    const { formatMessage } = this.props.intl;
    if (this.state.customerRedirect) {
      console.log("316 SIGNIN FORM IF customerRedirect");
      console.log("booking_data ON SIGN IN PAGE", this.state.booking_data);
      console.log("taskData ON SIGN IN PAGE", this.state.taskData);
      console.log("loginPath ON SIGN IN PAGE", this.state.loginPath);
      console.log("value", this.state.value)
      if (this.state.loginPath == 'BookingConfirm') {
        this.props.history.push(`/user/booking_confirm`,
          {
            taskData: this.state.taskData,
            booking_data: this.state.booking_data,
            BookingPath: this.props.location.state.BookingPath,
            taskDataFromConfirmPage: this.props.history.location.state.taskDataFromConfirmPage
          })
      } else if (this.state.loginPath == 'BookingConfirmAdressLogin' || this.state.loginPath === 'BookingConfirmAdressSignIn') {
        this.props.history.push(`/user/profile/`,
          {
            taskData: this.state.taskData,
            booking_data: this.state.booking_data,
            value: this.state.value,
            loginPath: this.state.loginPath,
            BookingPath: this.props.location.state.BookingPath,
            taskDataFromConfirmPage: this.props.history.location.state.taskDataFromConfirmPage
          })
      } else if (this.state.loginPath === 'BookingConfirmPaymentLogin' || this.state.loginPath === 'BookingConfirmPaymentSignIn') {
        this.props.history.push(`/user/profile/`,
          {
            taskData: this.state.taskData,
            booking_data: this.state.booking_data,
            value: this.state.value,
            loginPath: this.state.loginPath,
            res: this.state.res,
            BookingPath: this.props.location.state.BookingPath,
            taskDataFromConfirmPage: this.props.history.location.state.taskDataFromConfirmPage
          })
      } else if (this.state.loginPath == 'BookingConfirmAdressUpdate') {
        this.props.history.push(`/user/address/update/${this.state.key}`,
          {
            taskData: this.state.taskData,
            booking_data: this.state.booking_data,
            value: this.state.value,
            loginPath: this.state.loginPath,
            //       key: this.state.key,
            res: this.state.res,
            BookingPath: this.props.location.state.BookingPath,
            taskDataFromConfirmPage: this.props.history.location.state.taskDataFromConfirmPage
          })
      }
      else {
        this.props.history.push({ pathname: `/user/dashboard` });      //hereeeeeeeeeeeeee
      }
    }
    if (this.state.providerRedirect) {
      console.log("333 SIGNIN FORM IF providerRedirect");
      const getuserdata = async () => {
        const res = await userDetail();
        console.log("341 res insinde getuserdata func", res);
        if (res.data.detail.approved) {
          console.log("343 if approved");
          // this.props.history.push({ pathname: `/user/dashboard` });
          this.props.history.push({ pathname: `/provider/dashboard` });
        } else {
          console.log("346 else not approved");
          this.props.history.push({ pathname: `/user/profile/initial` });
        }

      }
      getuserdata();

      //this.handleClose();
    }


    if (this.state.samePage) {
      // this.handleClose();
      this.props.history.push({ pathname: this.props.renderUrl });
      /* return <Redirect to={this.props.renderUrl} />; */
    }
    return (
      <div>
        <div className="inn-page-bg">
          <div className="container">
            <div className="row">
              <div className="inn-pag-ban_div" />
              <div className="inn-pag-ban_div2" />
              <div className="inn-pag-ban">
                <h2>
                  <span>Thank You for Being a Customer!</span>
                </h2>
                <hr className="line" />
                <p class="refer_class">
                  Login and Book a Job in Potentially Seconds.
                </p>
              </div>
              <div class="icon_down" />
            </div>
          </div>
        </div>
        <div className="tz-register">

          {this.state.loginPath === 'BookingConfirm' &&
            <p style={{
              fontSize: 25,
              textAlign: 'center',
              marginTop: "50px",
            }}>Please login or signup to book a service
            </p>
          }
          {(this.state.loginPath === 'BookingConfirmPaymentLogin' || this.state.loginPath === 'BookingConfirmPaymentSignIn') &&
            <p style={{
              fontSize: 25,
              textAlign: 'center',
              marginTop: "50px",
            }}>Please login or signup to add Payment-Method
            </p>
          }
          {this.state.loginPath === 'BookingConfirmAdressLogin' || this.state.loginPath === 'BookingConfirmAdressSignIn' &&
            <p style={{
              fontSize: 25,
              textAlign: 'center',
              marginTop: "50px",
            }}>Please login or signup to add Address
            </p>
          }
          <div className="log-in-pop">
            <div className="log-in-pop-right">
              <a href="#" className="pop-close" data-dismiss="modal" />
              <h4>Login</h4>

              <form
                className="s12 ng-pristine ng-valid form-new"
                autoComplete="off"
              >
                <div
                  className="dialog-header"
                  style={{
                    backgroundColor: this.props.theme.palette.primary.main,
                  }}
                />
                <div className="dialog-body">

                  <p>Don’t forget your area code!</p>
                  <RadioGroup
                    className="md-12"
                    aria-label="accountType"
                    name="AccountType"
                    value={this.state.accountType}
                    onChange={this.handleChangeAccountType}
                    row
                  >
                    <FormControlLabel
                      className="d-flex"
                      style={{ flexDirection: "row" }}
                      value="420"
                      control={<Radio color="primary" />}
                      label="Customer"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      className="d-flex"
                      style={{ flexDirection: "row" }}
                      value="840"
                      control={<Radio color="primary" />}
                      label="Provider"
                      labelPlacement="end"
                    />
                  </RadioGroup>
                  <FormHelperText style={{ color: "red" }}>
                    {this.state.typeError}
                  </FormHelperText>
                  <div className="row" style={{ marginTop: -20 }}>
                    <div className="col-md-12 mb-2">
                      <TextField
                        error={phoneError ? true : false}
                        helperText={phoneError}
                        className="login-form-textfield"
                        label={formatMessage({
                          id: 'phone'
                        })}
                        id="phone"
                        fullWidth={true}
                        name="phone"
                        type="number"
                        placeholder="Enter Mobile"
                        value={this.state.phone}
                        onChange={e => {
                          const re = /^[0-9\b]+$/;
                          if (e.target.value === '' || re.test(e.target.value) && e.target.value.length <= 10) {
                            this.setState({
                              phone: e.target.value,
                              phoneError: "",
                              error: ""
                            })
                          }
                        }}
                        disabled={this.state.loaderButton || this.state.hideGetOtp}
                        margin="normal"
                      />

                      {this.state.showChangePhone && (
                        <a className="mb-2" style={{ justifyContent: "flex-end", display: "flex" }} href="javascript:void(0);">
                          <p
                            style={{
                              fontWeight: "normal",
                              ":hover": {
                                fontWeight: "bold",
                              }
                            }}
                            onClick={() => {
                              this.setState({
                                hideGetOtp: false,
                                hideLogin: true,
                                showChangePhone: false,
                                timer: 0,
                                loaderButton: false
                              })
                            }}>
                            Change Phone
                          </p>
                        </a>
                      )}
                    </div>
                  </div>
                  {!this.state.hideGetOtp &&
                    <div className="d-flex justify-content-center md-12">
                      {this.renderGetOtpButton()}
                    </div>}
                  {this.state.hideGetOtp &&
                    <div className="input-field s12" style={{ marginTop: -20, display: "flex", flexDirection: "column" }}>
                      <TextField
                        error={passwordError ? true : false}
                        helperText={passwordError}
                        className="login-form-textfield"
                        id="password"
                        fullWidth={true}
                        name="OTP"
                        label={"One Time Password"}
                        type="number"
                        placeholder="Enter One Time Password"
                        value={this.state.password}
                        onChange={event => {
                          if (event.target.value.length <= 8) {
                            this.setState({
                              password:
                                event.target.value,
                              passwordError: ''
                            });
                          }
                        }}
                        disabled={this.state.loaderButton}
                        margin={'normal'}
                      />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "end"
                        }}
                        className="input-field s12">
                        {!this.state.timer == 0 ? <a href="javascript:void(0);">
                          <p >
                            Resend One Time Password in&nbsp;
                            <span style={{
                              fontWeight: "bold",
                              color: "#0078ff"
                            }}>
                              0:{this.state.timer}
                            </span>
                          </p>
                        </a> : <a href="javascript:void(0);">
                          <p onClick={() => {
                            this.getOptCall()
                          }}>
                            Resend One Time Password
                          </p>
                        </a>}

                      </div>
                    </div>
                  }

                  {!hideLogin && (
                    <div className="d-flex justify-content-center md-12">
                      {this.renderLoginButton()}
                    </div>
                  )}
                </div>
                <div>
                  <div className="input-field s12 pt-3">
                    <a href="javascript:void(0);">
                      Not a member yet ?
                      <p
                        id="sign_font"
                        style={{ color: "#0077fd", fontWeight: "600", }} onClick={this.renderSignupPage}>Signup Now</p>
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <AppLinks settings={this.props.settings} />

        <CustomerVerification
          email={this.state.usedEmail}
          open={this.state.showCustomerVerification}
          closePopup={this.handleCustomClose}
        />
        <Verification
          email={this.state.usedEmail}
          open={this.state.showProviderVerification}
          close={this.handleVerifyClose}
        />
        <ForgotPassword
          email={this.state.usedEmail}
          open={this.state.showForgotPopup}
          close={this.handleForgotClose}
        />
      </div>
    );
  }
}
const mapStateToProps = ({ settings }) => {
  return { settings };
};
const composedHOC = compose(
  withTheme(),
  connect(
    mapStateToProps,
    actions
  )
);
export default composedHOC(injectIntl(SigninForm));



// WEBPACK FOOTER //
// ./src/views/LoginPage/SigninForm.jsx